import { createRootRoute, createRoute, createRouter, redirect, Outlet } from '@tanstack/react-router';
import { api } from './lib/api.js';
import { AdminShell } from './ui/AdminShell.js';
import { LoginPage } from './ui/LoginPage.js';
import { Dashboard } from './ui/Dashboard.js';
import { UsersPage } from './ui/UsersPage.js';
import { WorkspacesPage } from './ui/WorkspacesPage.js';
import { PlansPage } from './ui/PlansPage.js';
import { IntegrationsPage } from './ui/IntegrationsPage.js';
import { PromptsPage } from './ui/PromptsPage.js';
import { FlagsPage } from './ui/FlagsPage.js';
import { AuditPage } from './ui/AuditPage.js';
import { PaymentsPage } from './ui/PaymentsPage.js';
import { TwoFAPage } from './ui/TwoFAPage.js';
import { FocusAudioPage } from './ui/FocusAudioPage.js';

const root = createRootRoute({
  component: () => <Outlet />,
});

const loginRoute = createRoute({
  getParentRoute: () => root,
  path: '/login',
  component: LoginPage,
});

const shellRoute = createRoute({
  getParentRoute: () => root,
  id: 'shell',
  beforeLoad: async () => {
    try {
      const me = await api<{ admin: string | null }>('/auth/me');
      if (!me.admin) throw redirect({ to: '/login' });
    } catch {
      throw redirect({ to: '/login' });
    }
  },
  component: AdminShell,
});

const dashboardRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/',
  component: Dashboard,
});
const usersRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/users',
  component: UsersPage,
});
const workspacesRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/workspaces',
  component: WorkspacesPage,
});
const plansRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/plans',
  component: PlansPage,
});
const integrationsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/integrations',
  component: IntegrationsPage,
});
const promptsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/prompts',
  component: PromptsPage,
});
const flagsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/flags',
  component: FlagsPage,
});
const auditRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/audit',
  component: AuditPage,
});
const paymentsRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/payments',
  component: PaymentsPage,
});
const twoFaRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/2fa',
  component: TwoFAPage,
});
const focusAudioRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/focus-audio',
  component: FocusAudioPage,
});

const routeTree = root.addChildren([
  loginRoute,
  shellRoute.addChildren([
    dashboardRoute,
    usersRoute,
    workspacesRoute,
    plansRoute,
    integrationsRoute,
    promptsRoute,
    flagsRoute,
    auditRoute,
    paymentsRoute,
    twoFaRoute,
    focusAudioRoute,
  ]),
]);

export const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
